import { useState } from "react";
import {
  forgotPassword,
  loginUser,
  registerUser,
  resendCode,
  resetPassword,
  verifyCode,
} from "../apis/AuthApis";
import { useDispatch, useSelector } from "react-redux";
import { setUser, userLogin } from "../redux/action";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
const useAuthHooks = (onAuthSuccess) => {
  //all redux
  const dispatch = useDispatch();
  const navigateTo = useNavigate();

  //common functions in both screen
  const [loading, setLoading] = useState(false);
  const apiCallFunc = async (obj, apiFunc, onError) => {
    try {
      const apiData = await apiFunc(obj, onError);
      console.log('✌️apiData --->', apiData);

      return { success: true, apiData };
    } catch (e) {
      console.log(e);
      return { success: false, error: e };
    }
  };




  const [credentials, setCredentials] = useState({
    email: "",
    password: "",
    agree: false,
    rememberMe: true,
  });


  const onPressLoginBtn = async () => {
    if (credentials?.email === "" || credentials?.password === "") {
      toast.error("Please fill all the fields");
      return;
    }

    if (credentials.agree === false) {
      toast.error("Please accept terms of service and privacy policy");
      return;
    }

    setLoading(true);
    let obj = {
      email: credentials?.email,
      password: credentials?.password,
    };

    const result = await apiCallFunc(obj, loginUser);


    if (result?.success && result?.apiData?.user) {
      setLoading(false);
      dispatch(userLogin(result.apiData.user));
      onAuthSuccess(result.apiData.user);
    } else {
      setLoading(false);
      toast.error(result?.response?.data?.message);
    }
  };

  //all signup screen states and functions
  const [signupCredentials, setSignupCredentials] = useState({
    email: "",
    password: "",
    confirmPassword: "",
    firstName: "",
    lastName: "",
    role: "contributor",
    country: "",
    city: "",
  });

  //all functions
  const onRegistrationError = (errormsg) => {
    setSignupCredentials((prev) => ({ ...prev, error: errormsg }));
  };

  const onPressRegisterBtn = async () => {
    //all regex
    const passwordRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#^+=(){}[\]|\\<>.,:;'"_-]).{8,}$/;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
    const password = signupCredentials?.password;

    if (
      signupCredentials?.email === "" ||
      signupCredentials?.firstName === "" ||
      signupCredentials?.lastName === "" ||
      signupCredentials?.role === "" ||
      signupCredentials?.country === "" ||
      signupCredentials?.city === ""
    ) {
      onRegistrationError("Please fill all the fields");
      return;
    }

    if (!password) {
      onRegistrationError("Password is required");
      return;
    }

    if (password.length < 8) {
      onRegistrationError("Password must be at least 8 characters long");
      return;
    }

    if (!passwordRegex.test(password)) {
      onRegistrationError(
        "Password must contain at least one uppercase letter, one lowercase letter, one number, and one special character"
      );
      return;
    }
    if (password !== signupCredentials?.confirmPassword) {
      onRegistrationError("Password does not match");
      return;
    }

    if (!emailRegex.test(signupCredentials?.email)) {
      onRegistrationError("Invalid email format");
      return;
    }

    let obj = {
      name: {
        first: signupCredentials?.firstName,
        last: signupCredentials?.lastName,
      },
      email: signupCredentials?.email,
      password: signupCredentials?.password,
      preferenceRole: [signupCredentials.role],
      address: {
        country: signupCredentials?.country,
        city: signupCredentials?.city,
      },
    };

    apiCallFunc(obj, registerUser, onRegistrationError).then((r) => {
      if (r?.apiData?.user) {
        dispatch(setUser(r?.apiData?.user));
        onAuthSuccess(r?.apiData?.user);
      }
    });
  };

  //all forgot password screen states and functions

  //all local states
  const [forgotCredintials, setForgotCredentials] = useState({
    email: "",
    code: "",
  });
  const [isEnteringCode, setisEnteringCode] = useState(false);

  //all functions

  const onSuccessCodeSent = (message) => {
    setForgotCredentials((prev) => ({ ...prev, successMessage: message }));
  };

  const onPressConfirmBtn = () => {
    if (forgotCredintials?.email === "") {
      toast.error("Please enter email address");
      return;
    }

    let obj = {
      email: forgotCredintials?.email,
    };
    forgotPassword(obj, onSuccessCodeSent);
  };

  const onCodeError = (message) => {
    setForgotCredentials((prev) => ({ ...prev, error: message }));
  };
  const onSuccessCode = (message) => {
    setForgotCredentials((prev) => ({ ...prev, successMessage: message }));
  };

  const onPressConfirmSuccessfulyCodeSendForgotPassword = () => {
    setisEnteringCode(true);
    setForgotCredentials((prev) => ({ ...prev, successMessage: "" }));
  };

  const onPressResetPasswordConfirmBtn = () => {
    setForgotCredentials((prev) => ({ ...prev, successMessage: "" }));
    let payload = {
      email: forgotCredintials?.email,
      code: forgotCredintials?.code,
    };
    navigateTo("/reset-password", { state: payload });
  };

  const onPressConfirmVerifyBtn = () => {
    let obj = {
      email: forgotCredintials?.email,
      code: forgotCredintials?.code,
    };
    verifyCode(obj, onCodeError, onSuccessCode);
  };

  const onPressResendCodeBtn = () => {
    let obj = {
      email: forgotCredintials?.email,
    };
    resendCode(obj);
  };

  //reset password screen states and functions
  //all routes data
  const location = useLocation();
  const state = location?.state;
  //all local states

  const [resetCreditionals, setResetCreditionals] = useState({
    password: "",
  });

  //all functions

  const onSucessResetPassword = (message) => {
    setResetCreditionals((prev) => ({ ...prev, successMessage: message }));
  };
  const onResetPasswordError = (message) => {
    console.log({ message });
    setResetCreditionals((prev) => ({ ...prev, error: message }));
  };

  const onPressResetSubmitBtn = () => {
    let payload = {
      email: state?.email,
      code: state?.code,
      newPassword: resetCreditionals?.password,
    };
    console.log({ payload });
    resetPassword(payload, onResetPasswordError, onSucessResetPassword);
  };
  return {
    //all login  Screen states

    //all local states
    credentials,
    setCredentials,

    //all functions
    onPressLoginBtn,

    //all signup screen states

    //all local states
    signupCredentials,
    setSignupCredentials,

    //all functions
    onPressRegisterBtn,

    //all forgot password screen states

    //all local states
    forgotCredintials,
    setForgotCredentials,
    isEnteringCode,

    //all functions
    onPressConfirmBtn,
    onPressConfirmVerifyBtn,
    onPressResendCodeBtn,
    onPressConfirmSuccessfulyCodeSendForgotPassword,
    onPressResetPasswordConfirmBtn,

    //all resest password screen states

    //all local states
    resetCreditionals,
    setResetCreditionals,

    //all functions
    onPressResetSubmitBtn,
    loading,
  };
};

export default useAuthHooks;
